/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useEffect, useState } from "react";

import { usePlayerController } from "../BasePlayer";

export const usePlayerLoadingState = () => {
  const [isLoading, setLoadingState] = useState<boolean>(false);

  const { player } = usePlayerController();

  useEffect(() => {
    const showUnsubscribe = player.onEvent(
      ["seeking", "waiting", "adloading"],
      () => setLoadingState(true),
    );

    const onEnded = player.onEvent(
      ["seeking"],
      () => player.duration() === player.currentTime() && player.pause(),
    );

    const hideUnsubscribe = player.onEvent(
      ["seeked", "canplay", "playing", "ended", "custom-error", "adstarted"],
      () => setLoadingState(false),
    );

    return () => {
      showUnsubscribe();
      hideUnsubscribe();
      onEnded();
    };
  }, [player]);

  return { isLoading };
};
